<template>
  <div>
    <Header />
    <main>
      <router-view v-if="!isPageNotFound" name="mainContent" />
      <div v-else class="page_not_found">
        <h1 class="page_not_found-heading_text">
          404
        </h1>
        <router-link to="/" class="page_not_found-back_to_home">
          Back to home page
        </router-link>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
    Header: () => import('@/components/Header/Symposium.vue')
  },

  computed: {
    ...mapState({
      isPageNotFound: state => state.symposium.isPageNotFound,
      notDateActivate: state => state.symposium.notDateActivate
    })
  },

  watch: {
    '$route' () {
      this.$store.dispatch('symposium/checkDateAvailable')
    },

    notDateActivate () {
      if (this.notDateActivate) {
        this.$router.push('/symposium')
      }
    }
  },

  created () {
    this.$store.dispatch('symposium/checkDateAvailable')
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

main {
  margin-top: 120px;

  @media only screen and (max-width: $break-l) {
    margin-top: 66px;
  }
}

.page_not_found {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 44px;
  min-height: calc(100vh - 120px);

  @media only screen and (max-width: $break-l) {
    min-height: calc(100vh - 66px);
  }

  &-heading_text {
    text-align: center;
    font-weight: 700;
    font-size: 84px;
  }

  &-back_to_home {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    max-width: 180px;
    width: 100%;
    height: 32px;
    border-radius: 4px;
    background-color: #E42201;
    text-align: center;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>
